import { useTranslation } from 'react-i18next';
import { FormControl, MenuItem } from '@mui/material';

import { CustomFormLabel, RHFSelect } from '@/components/form-controls';
import { useBrands } from '@/shared/hooks/useBrands';

type BrandFieldsProps = {
  isRequired?: boolean;
};

export const BrandField = (props: BrandFieldsProps) => {
  const { isRequired = false } = props;
  const { t } = useTranslation('nomenclature-page');

  const { brands } = useBrands();

  return (
    <FormControl fullWidth>
      <CustomFormLabel isRequired={isRequired} htmlFor="brand_id">
        {t('modals.form.ui.expert-data.brand')}
      </CustomFormLabel>
      <RHFSelect fullWidth name="brand_id" id="brand_id" variant="filled">
        {brands.map(brand => (
          <MenuItem value={brand.id} key={brand.id}>
            {brand.name}
          </MenuItem>
        ))}
      </RHFSelect>
    </FormControl>
  );
};
